import React from 'react';
import FeatureCard from './FeatureCard';

const FeaturesSection = () => {
  const features = [
    {
      iconName: "UserX",
      title: "We Encourage Anonymity",
      description: "We prioritize your privacy and encourage anonymous sharing. If a post is not anonymous, we can remove it to protect your identity and maintain a safe space for emotional expression.",
      accentColor: "var(--color-primary)"
    },
    {
      iconName: "Heart",
      title: "Supportive Reactions Only",
      description: "Receive empathy through curated reactions: 'I relate to you', 'You are correct', or 'Not the best choice'. No toxic comments, just understanding and support from peers.",
      accentColor: "var(--color-accent)"
    },
    {
      iconName: "ShieldCheck",
      title: "Toxicity-Free Environment",
      description: "No open comments means no judgment, no trolling, no negativity. Only structured, supportive feedback that helps you feel heard and validated in your emotional journey.",
      accentColor: "var(--color-success)"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-background">
      <div className="container mx-auto max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16 space-y-3 md:space-y-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            Why Choose OnlyCuts?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            A safe haven designed specifically for emotional expression without fear of judgment or toxicity.
          </p>
        </div>

        {/* Feature cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <FeatureCard
              key={index}
              iconName={feature?.iconName}
              title={feature?.title}
              description={feature?.description}
              accentColor={feature?.accentColor}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;